// Avisos do sino: resultado dos "Receber" manuais concluídos (mesmo com a tela fechada)
import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const fmtD = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "");
const fmtDH = (s) => (s ? new Date(s).toLocaleString("pt-BR") : "");

const Aviso = ({ a }) => {
  const ok = a.resultado === "sucesso";
  return (
    <li className={`border rounded-lg p-3 text-sm ${ok ? "border-emerald-200 bg-emerald-50" : "border-red-200 bg-red-50"}`} data-testid={`aviso-coleta-${a.id}`}>
      <div className="flex items-center gap-2 font-semibold">
        {ok ? <CheckCircle2 size={15} className="text-emerald-600" /> : <AlertTriangle size={15} className="text-red-600" />}
        <span data-testid={`aviso-coleta-titulo-${a.id}`}>{ok ? "Recebimento concluído" : a.resultado === "parcial" ? "Recebimento concluído com falhas" : "Recebimento não concluído"}</span>
        {!a.lido && <span className="px-1.5 py-0.5 rounded bg-indigo-600 text-white text-[9px] font-bold">NOVO</span>}
        <span className="ml-auto text-[10px] text-slate-500 font-normal">{fmtDH(a.created_at)}</span>
      </div>
      <div className="text-xs text-slate-700 mt-1" data-testid={`aviso-coleta-resumo-${a.id}`}>
        Período {fmtD(a.de)} a {fmtD(a.ate)} · {a.coletores} coletor(es) · {a.recebidos} registro(s) lido(s) · <b>{a.novas} nova(s)</b> · {a.duplicadas} já existente(s)
      </div>
      {(a.falhas || []).map((f, i) => (
        <div key={i} className="text-[11px] text-red-700 mt-0.5"><b>{f.nome}:</b> {f.motivo} — tente novamente pelo botão Receber.</div>
      ))}
    </li>
  );
};

export const AvisosColeta = ({ onLidos }) => {
  const [itens, setItens] = useState(null);
  useEffect(() => {
    api.get("/cartao-ponto/receber-avisos").then((r) => {
      setItens(r.data || []);
      if ((r.data || []).some((a) => !a.lido)) api.post("/cartao-ponto/receber-avisos/lidos").then(() => onLidos?.()).catch(() => {});
    }).catch(() => setItens([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (itens === null) return <div className="text-center text-slate-400 py-8"><Loader2 size={18} className="animate-spin mx-auto" /></div>;
  if (!itens.length) return <div className="text-center text-slate-400 py-8 text-sm" data-testid="avisos-coleta-vazio">Nenhum recebimento concluído ainda.</div>;
  return <ul className="space-y-2" data-testid="avisos-coleta-lista">{itens.map((a) => <Aviso key={a.id} a={a} />)}</ul>;
};
